/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { VehicleModel } from '../models/vehicle-model';

@Injectable({
  providedIn: 'root',
})
export class VehiclesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getVehicleByPlate
   */
  static readonly GetVehicleByPlatePath = '/api/vehicles/plate/{plate}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVehicleByPlate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicleByPlate$Response(params: {
    plate: string;
    context?: HttpContext
  }
): Observable<StrictHttpResponse<VehicleModel>> {

    const rb = new RequestBuilder(this.rootUrl, VehiclesService.GetVehicleByPlatePath, 'get');
    if (params) {
      rb.path('plate', params.plate, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<VehicleModel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVehicleByPlate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVehicleByPlate(params: {
    plate: string;
    context?: HttpContext
  }
): Observable<VehicleModel> {

    return this.getVehicleByPlate$Response(params).pipe(
      map((r: StrictHttpResponse<VehicleModel>) => r.body as VehicleModel)
    );
  }

}
